import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

// layout constants
import { LayoutTypes } from "../constants/layout";

// store
import { RootState } from "../redux-rtk/store";

// All layouts containers
import DefaultLayout from "../layouts/Default";
import VerticalLayout from "../layouts/Vertical";
import DetachedLayout from "../layouts/Detached";
import HorizontalLayout from "../layouts/Horizontal/";
import TwoColumnLayout from "../layouts/TwoColumn/";
import Unauthorized from "pages/other/Unauthorized";

import {
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
} from "./index";
import { APICore } from "../helpers/api/apiCore";

interface IRoutesProps {}

const AllRoutes = (props: IRoutesProps) => {
  const { layout, user, userLoggedIn } = useSelector((state: RootState) => ({
    layout: state.Layout,
    user: state.Auth.user,
    userLoggedIn: state.Auth.userLoggedIn,
  }));

  const getLayout = () => {
    let layoutCls = TwoColumnLayout;

    switch (layout.layoutType) {
      case LayoutTypes.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case LayoutTypes.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      case LayoutTypes.LAYOUT_VERTICAL:
        layoutCls = VerticalLayout;
        break;
      default:
        layoutCls = TwoColumnLayout;
        break;
    }
    return layoutCls;
  };

  const equalsCheck = (a: any, b: any) => {
    if(!a?.length || !b?.length) return false;
    let status = false;
    a.forEach((elA: any) => {
      b.forEach((elB: any) => {
        if(elA == elB){
          status = true;
        }
      });
    });
    return status;
  }

  let Layout = getLayout();
  const api = new APICore();

  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicProtectedFlattenRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <DefaultLayout {...props} layout={layout}>
                  {route.element}
                </DefaultLayout>
              }
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {authProtectedFlattenRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                userLoggedIn === false ? (
                  <Navigate
                    to={{
                      pathname: "/auth/login",
                      // hash:route.path,
                      search: "next=" + route.path,
                    }}
                  />
                ) : (
                  equalsCheck(route.roles || [], user.roles) ? (
                    <>
                      <Layout {...props}>{route.element}</Layout>
                      <ToastContainer />
                    </>
                  ) : <Unauthorized />
                )
              }
              key={idx}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default AllRoutes;
